import React from 'react';
import { useTranslation } from 'react-i18next';
import { getStoreStrings } from '@/utils/storeRedirectStrings';

/**
 * /ios — Simple Coming Soon page for native iOS release.
 */
const IosComingSoon = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language || 'en';
  const isRTL = lang === 'ar' || lang === 'ur' || lang === 'fa';
  const t = getStoreStrings(lang);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'radial-gradient(circle at 50% 0%, #14213D 0%, #050914 60%, #000 100%)',
        color: '#E5E7EB',
        padding: '48px 20px 80px',
        fontFamily: 'system-ui, -apple-system, "Segoe UI", Tahoma, sans-serif',
      }}
      dir={isRTL ? 'rtl' : 'ltr'}
      data-testid="ios-coming-soon-page"
    >
      <div style={{ maxWidth: 520, margin: '0 auto', textAlign: 'center' }}>
        {/* Crescent logo */}
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            margin: '48px auto 28px',
            background: 'radial-gradient(circle at 35% 35%, #FDE68A 0%, #F59E0B 40%, #1F2937 70%)',
            boxShadow: '0 0 48px rgba(253, 230, 138, 0.35)',
          }}
        />

        <h1
          style={{
            fontSize: 26,
            fontWeight: 700,
            margin: '0 0 20px',
            letterSpacing: 0.3,
            lineHeight: 1.3,
          }}
        >
          {t.iosTitle}
        </h1>

        <p style={{ color: '#CBD5E1', fontSize: 16, lineHeight: 1.65, margin: '0 0 40px' }}>
          {t.iosBody}
        </p>

        <a
          href="/"
          style={{
            display: 'inline-block',
            padding: '14px 32px',
            borderRadius: 999,
            background: 'transparent',
            border: '1px solid rgba(245, 158, 11, 0.6)',
            color: '#F59E0B',
            fontWeight: 600,
            fontSize: 15,
            textDecoration: 'none',
            letterSpacing: 0.3,
          }}
          data-testid="ios-back-button"
        >
          {t.backHome}
        </a>
      </div>
    </div>
  );
};

export default IosComingSoon;
